var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt2-sg wt2-masthead-info-icon",class:{ '-active': _vm.getActionPanelOpenStatus },attrs:{"title":_vm.title},on:{"click":_vm.toggleActionPanel}},[_c('i',{staticClass:"wticon wticon-information1"})])}
var staticRenderFns = []

export { render, staticRenderFns }